export const filterResetValues = {
    from: "",
    to: "",
    supervisors: [],
    employees: [],
    farms: [],
  }